// extracted by css-extract-rspack-plugin
export default {"cls1":"Accordion-cls1_ioM","cls2":"Accordion-cls2_v0D Accordion-cls1_ioM"};